import {
  Box,
  Button,
  ButtonGroup,
  HStack,
  IconButton,
  Input,
  Text,
} from "@chakra-ui/react";
import { FaLocationArrow, FaTimes } from "react-icons/fa";

import { Autocomplete } from "@react-google-maps/api";
import useMapContext from "../hooks/useMapContext";
export default function ToolBar() {
  const mapContext = useMapContext();

  return (
    <>
      {mapContext.closeDuration ? (
        <Button
          className="closest"
          colorScheme="pink"
          onClick={() => {
            mapContext.setCloseDuration(false);
          }}
        >
          Closest
        </Button>
      ) : (
        <Box
          p={4}
          borderRadius="lg"
          m={4}
          bgColor="white"
          shadow="base"
          minW="container.md"
          zIndex="2"
        >
          <HStack spacing={2} justifyContent="space-between">
            <Box flexGrow={1}>
              <Autocomplete>
                <Input
                  type="text"
                  placeholder="Origin"
                  ref={mapContext.originRef}
                />
              </Autocomplete>
            </Box>
            <Box flexGrow={1}>
              <Autocomplete>
                <Input
                  type="text"
                  placeholder="Destination"
                  ref={mapContext.destiantionRef}
                />
              </Autocomplete>
            </Box>

            <ButtonGroup>
              <Button
                colorScheme="pink"
                type="submit"
                onClick={mapContext.calculateRoute}
              >
                Calculate Route
              </Button>
              <IconButton
                aria-label="center back"
                icon={<FaTimes />}
                onClick={() => {
                  mapContext.clearRoute();
                  mapContext.setCloseDuration(true);
                }}
              />
            </ButtonGroup>
          </HStack>
          <HStack spacing={4} mt={4} justifyContent="space-between">
            <Text>Distance: {mapContext.distance} </Text>
            <Text>Duration: {mapContext.duration} </Text>
            <IconButton
              aria-label="center back"
              icon={<FaLocationArrow />}
              isRound
              onClick={() => {
                mapContext.map.panTo(mapContext.center);
                mapContext.map.setZoom(15);
              }}
            />
          </HStack>
        </Box>
      )}
    </>
  );
}
